import { render } from "./NewBrand.vue?vue&type=template&id=8e19d60a&scoped=true"
import script from "./NewBrand.vue?vue&type=script&lang=js"
export * from "./NewBrand.vue?vue&type=script&lang=js"

import "./NewBrand.vue?vue&type=style&index=0&id=8e19d60a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e19d60a"]])

export default __exports__